import api from 'Application/api/api';

const giveTemplateQuestionYesNoAnswer = (
    templateId,
    questionId,
    isCustom,
    answer,
    cancelToken = null,
) =>
    api.post(
        `project-manager/templates/${templateId}/questionnaire/questions/${questionId}/${
            isCustom ? 1 : 0
        }/answers/yes-no`,
        {
            answer,
        },
        { cancelToken },
    );

export default giveTemplateQuestionYesNoAnswer;
